import React, { Fragment, useEffect } from "react";
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  NativeSelect,
  Divider,
  RadioGroup,
  FormControlLabel,
  makeStyles,
  Radio,
} from "@material-ui/core";
import { palette } from "configurations/styles/theme";
import PageviewIcon from "@material-ui/icons/Pageview";
import useMultipleFiscalReference, {
  BootstrapInput,
} from "hooks/useMultipleFiscalReference";
import { tipoContribuyente } from "views/facturacion/Forms/typeVoucher";
import { format } from "date-fns";
import { useState } from "react";
import { httpRepo } from "configurations/axios";
import { API_GET_VOUCHER_BY_CUFE } from "views/facturacion/AuthorizedIssuedVouchers/apis";
import { useSnackbar } from "notistack";
import checkInputs from "utils/checkInputs";

const useStyles = makeStyles((theme) => ({
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "0%",
    textAlign: "justify",
  },
  divInput: {
    marginBottom: "0%",
    paddingRight: "0%",
    paddingLeft: "0%",
    textAlign: "justify",
  },
}));

const MultipleFiscalReference = ({
  documentosFiscales,
  setDocumentosFiscales,
  viewPago,
  setViewPago,
  iDoc,
}) => {
  const dateTodayOut = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss");

  const [voucher, setVoucher] = useState({});
  const [errors, setErrors] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const {
    setDocumentoFiscal,
    classes,
    classesApp,
    classesGlobal,
    open,
    documentoFiscal,
    empty,
    rucEmisor,
    setRucEmisor,
    isData,
    setIsData,
    cufe,
    setCufe,
    handleClickOpen,
    handleClose,
    handleAddDocumentFiscal,
    handleChangeUniversal,
    handleChangeRuc,
  } = useMultipleFiscalReference(
    documentosFiscales,
    setDocumentosFiscales,
    viewPago,
    setViewPago,
    iDoc
  );

  const handleChangeCheck = (event) => {
    setDocumentoFiscal({
      rucEmisor: {},
      nombreEmisor: "",
      fechaDocumento: "",
      cufeReferenciada: "",
      nroFacturaPapel: "",
      nroFacturaImpresora: "",
    });
    setRucEmisor({
      tipoRuc: "",
      ruc: "",
      dv: "",
    });
    setCufe("");
    setIsData(event.target.value);
  };

  const handleChangeCufe = (e) => {
    setCufe(e.target.value);
  };

  const validateCufe = () => {
    let error = {};
    if (checkInputs.countLenth(cufe) !== 66) {
      error.cufe = "Ingrese 66 caracteres referentes al CUFE referenciado.";
    }
    return error;
  };

  useEffect(() => {
    setRucEmisor({
      ...rucEmisor,
      ruc: voucher.rucEmisor,
      tipoRuc: voucher.tipoContribuyenteEmisor,
      dv: voucher.dvEmisor,
    });
    setDocumentoFiscal({
      ...documentoFiscal,
      nombreEmisor: voucher.razonSocialEmisor,
      fechaDocumento: voucher.fechaEmision,
      cufeReferenciada: voucher.cufe,
    });
  }, [setVoucher, voucher]);

  const searchBill = async () => {
    const newErrors = validateCufe();
    setErrors(newErrors);
    let isValid = Object.entries(newErrors).length > 0;
    if (!isValid) {
      await httpRepo
        .get(API_GET_VOUCHER_BY_CUFE + cufe)
        .then((response) => {
          if (response.status === 200) {
            if (response.data != null && response.data != "") {
              setVoucher(response.data);
            } else {
              enqueueSnackbar(
                `No existen un comprobante con el cufe ingresado`,
                {
                  variant: "info",
                  anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                  },
                }
              );
            }
          }
        })
        .catch(() => {
          enqueueSnackbar(
            `Existen problemas para consultar el CUFE contactese con el administrador`,
            {
              variant: "info",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            }
          );
        });
    }
  };

  return (
    <Fragment>
      <Grid container justify="center" className={classes.divButton}>
        <Button variant="outlined" color="primary" onClick={handleClickOpen}>
          Agregar Datos de Documento Fiscal Referenciado
        </Button>
      </Grid>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">
          Nuevo documento fiscal referenciado{" "}
        </DialogTitle>
        <DialogContent>
          {iDoc.CODIGO === "NCR" || iDoc.CODIGO === "NDR" ? (
            <Grid item xs={12} md={12} className={classes.divForm}>
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="datosCliente"
                  name="isData"
                  value={isData}
                  className={classes.radio}
                  required
                  onChange={handleChangeCheck}
                >
                  <FormControlLabel
                    value="DE"
                    control={
                      <Radio color="primary" className={classes.radioButton} />
                    }
                    label="Documento Externo"
                    labelPlacement="start"
                    className={classes.radioLable}
                  />
                  <FormControlLabel
                    value="DF"
                    control={
                      <Radio color="primary" className={classes.radioButton} />
                    }
                    label="Documento Generado en Emagic"
                    labelPlacement="start"
                    className={classes.radioLable}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          ) : null}
          <form>
            <Grid container>
              <Grid item xs={12} md={10} className={classes.divForm}>
                <input
                  type="text"
                  placeholder="Ej. FE0610000155705519-2-2021-0199992023020100000000149990126728388791"
                  name="cufe"
                  value={cufe}
                  onChange={handleChangeCufe}
                  autoComplete="off"
                  hidden={isData == "DE" ? true : false}
                  className={
                    cufe
                      ? cufe
                        ? "form-control is-valid"
                        : "form-control"
                      : "form-control"
                  }
                />
                {errors.cufe != null && (
                  <p className={classesApp.errorLetters}>{errors.cufe}</p>
                )}
              </Grid>
              <Grid item xs={12} md={2} className={classes.divForm}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: 15 }}
                  align="center"
                  hidden={isData == "DE" ? true : false}
                  startIcon={<PageviewIcon />}
                  onClick={() => searchBill()}
                >
                  {" "}
                  Buscar
                </Button>
              </Grid>
              <Grid item xs={12} md={12}>
                <label>
                  Los campos marcados con ({" "}
                  <font color={palette.error.main}> *</font> ) son obligatorios:
                </label>
              </Grid>

              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>
                  RUC contribuyente del emisor :{" "}
                  <font color={palette.error.main}>*</font>
                </label>
              </Grid>
              <Grid item xs={12} md={8} className={classes.divInput}>
                <input
                  type="text"
                  placeholder="Ej. 17457485626"
                  name="ruc"
                  value={rucEmisor.ruc}
                  onChange={handleChangeRuc}
                  autoComplete="off"
                  disabled={isData == "DE" ? false : true}
                  className={
                    rucEmisor
                      ? rucEmisor.ruc
                        ? "form-control is-valid"
                        : "form-control"
                      : "form-control"
                  }
                />

                {empty.ruc != null && (
                  <p className={classesApp.errorLetters}>{empty.ruc}</p>
                )}
              </Grid>
              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>
                  Tipo de contribuyente:{" "}
                  <font color={palette.error.main}>*</font>{" "}
                </label>
              </Grid>
              <Grid item xs={12} md={8} className={classes.divInput}>
                <FormControl className={classesGlobal.select}>
                  <NativeSelect
                    value={rucEmisor.tipoRuc}
                    name="tipoRuc"
                    disabled={isData == "DE" ? false : true}
                    onChange={handleChangeRuc}
                    input={<BootstrapInput />}
                  >
                    <option aria-label="None" value="">
                      --Seleccione--
                    </option>
                    {tipoContribuyente.map((element) => (
                      <option key={element.CODIGO} value={element.CODIGO}>
                        {element.NOMBRE}
                      </option>
                    ))}
                  </NativeSelect>
                </FormControl>
                {empty.tipoRuc != null && (
                  <p className={classesApp.errorLetters}>{empty.tipoRuc}</p>
                )}
              </Grid>

              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>
                  Dígito verificador del contribuyente:{" "}
                  <font color={palette.error.main}>*</font>{" "}
                </label>
              </Grid>
              <Grid item xs={12} md={8} className={classes.divInput}>
                <input
                  type="text"
                  name="dv"
                  value={rucEmisor.dv}
                  onChange={handleChangeRuc}
                  autoComplete="off"
                  disabled={isData == "DE" ? false : true}
                  className={
                    rucEmisor
                      ? rucEmisor.dv
                        ? "form-control is-valid"
                        : "form-control"
                      : "form-control"
                  }
                />
                {empty.dv != null && (
                  <p className={classesApp.errorLetters}>{empty.dv}</p>
                )}
              </Grid>
              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>
                  Nombre del emisor: <font color={palette.error.main}>*</font>{" "}
                </label>
              </Grid>
              <Grid item xs={12} md={8} className={classes.divInput}>
                <input
                  type="text"
                  name="nombreEmisor"
                  value={documentoFiscal.nombreEmisor}
                  onChange={handleChangeUniversal}
                  autoComplete="off"
                  disabled={isData == "DE" ? false : true}
                  className={
                    documentoFiscal
                      ? documentoFiscal.nombreEmisor
                        ? "form-control is-valid"
                        : "form-control"
                      : "form-control"
                  }
                />
                {empty.nombreEmisor != null && (
                  <p className={classesApp.errorLetters}>
                    {empty.nombreEmisor}
                  </p>
                )}
              </Grid>

              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>
                  Fecha de emisión del documento fiscal:{" "}
                  <font color={palette.error.main}>*</font>
                </label>
              </Grid>

              <Grid item xs={12} md={8} className={classes.divInput}>
                <input
                  className={
                    documentoFiscal
                      ? documentoFiscal.fechaDocumento
                        ? "form-control is-valid"
                        : "form-control"
                      : "form-control"
                  }
                  type="datetime-local"
                  name="fechaDocumento"
                  format="yyyy-MM-dd'T'HH:mm:ssXXX"
                  max={dateTodayOut}
                  value={documentoFiscal.fechaDocumento}
                  onChange={handleChangeUniversal}
                  autoComplete="off"
                  disabled={isData == "DE" ? false : true}
                  step="10"
                />
                {empty.fechaDocumento != null && (
                  <p className={classesApp.errorLetters}>
                    {empty.fechaDocumento}
                  </p>
                )}
              </Grid>
              <Divider />
              <Grid item md={12} xs={12}>
                <label>
                  <font color={palette.info.dark}>
                    {" "}
                    INFORMACIÓN DE REFERENCIA
                  </font>
                </label>
                <br></br>
                <label>
                  <font color={palette.info.dark}>
                    {" "}
                    Sólo debe utilizar una de las siguientes opciones:
                  </font>
                </label>
                {empty.informacionReferencia != null && (
                  <p className={classesApp.errorLetters}>
                    {empty.informacionReferencia}
                  </p>
                )}
              </Grid>
              {iDoc.CODIGO === "NCR" || iDoc.CODIGO === "NDR" ? (
                <Fragment>
                  <Grid item xs={12} md={4} className={classes.divForm}>
                    <label>CUFE de FE referenciada: </label>
                  </Grid>
                  <Grid item xs={12} md={8} className={classes.divInput}>
                    <input
                      type="text"
                      name="cufeReferenciada"
                      value={documentoFiscal.cufeReferenciada}
                      onChange={handleChangeUniversal}
                      autoComplete="off"
                      disabled={isData == "DE" ? false : true}
                      className={
                        documentoFiscal
                          ? documentoFiscal.cufeReferenciada
                            ? "form-control is-valid"
                            : "form-control"
                          : "form-control"
                      }
                    />
                    {empty.cufeReferenciada != null && (
                      <p className={classesApp.errorLetters}>
                        {empty.cufeReferenciada}
                      </p>
                    )}
                  </Grid>
                </Fragment>
              ) : null}
              {iDoc.CODIGO !== "NCR" && iDoc.CODIGO !== "NDR" ? (
                <Fragment>
                  <Grid item xs={12} md={4} className={classes.divForm}>
                    <label>Número de factura en papel : </label>
                  </Grid>
                  <Grid item xs={12} md={8} className={classes.divInput}>
                    <input
                      type="text"
                      name="nroFacturaPapel"
                      value={documentoFiscal.nroFacturaPapel}
                      onChange={handleChangeUniversal}
                      autoComplete="off"
                      className={
                        documentoFiscal
                          ? documentoFiscal.nroFacturaPapel
                            ? "form-control is-valid"
                            : "form-control"
                          : "form-control"
                      }
                    />
                    {empty.nroFacturaPapel != null && (
                      <p className={classesApp.errorLetters}>
                        {empty.nroFacturaPapel}
                      </p>
                    )}
                  </Grid>
                  <Grid item xs={12} md={4} className={classes.divForm}>
                    <label>
                      Número de factura emitida por impresora fiscal :{" "}
                    </label>
                  </Grid>
                  <Grid item xs={12} md={8} className={classes.divInput}>
                    <input
                      type="text"
                      name="nroFacturaImpresora"
                      value={documentoFiscal.nroFacturaImpresora}
                      onChange={handleChangeUniversal}
                      autoComplete="off"
                      className={
                        documentoFiscal
                          ? documentoFiscal.nroFacturaImpresora
                            ? "form-control is-valid"
                            : "form-control"
                          : "form-control"
                      }
                    />
                    {empty.nroFacturaImpresora != null && (
                      <p className={classesApp.errorLetters}>
                        {empty.nroFacturaImpresora}
                      </p>
                    )}
                  </Grid>
                </Fragment>
              ) : null}

              <Grid container spacing={3} justify="center">
                <Grid item md={12} xs={12}>
                  <Divider />
                </Grid>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddDocumentFiscal}
                  className={classesGlobal.marginButton}
                >
                  Agregar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  className={classesGlobal.marginButton}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default MultipleFiscalReference;
